<div class="mct-flex mct-row mct-justify-between mct-items-start"  >
  <h4>{{ 'profiles.view.primary-relationships.label' | translate | titlecase }}</h4>
  <div class="mct-flex mct-row mct-wrap mct-justify-start mct-items-center mct-gap-27">
    <a (click)="relateExistingProfile()" *ngIf="relatedProfilesAccess == 2">{{
      'profiles.relationships.relate-existing' | translate | titlecase
    }}</a>
    <a data-cy="aRelateNewProfile" (click)="relateNewProfileClick()" *ngIf="relatedProfilesAccess == 2">{{
      'profiles.relationships.relate-new' | translate | titlecase
    }}</a>
    <a [routerLink]="['/profile', profileId, 'relationships']" class="">
      {{ 'profiles.view.primary-relationships.manage-all' | translate | titlecase }}
      <i class="pi pi-angle-double-right"></i>
    </a>
  </div>
</div>
<div *ngFor="let profile of profileRelations.Result" class="primary-relations-container" #relationsContainer>
  <div class="mct-flex mct-justify-start mct-items-stretch"
    [ngClass]="
      profile.IsMainContact
        ? 'main-contact primary-relation'
        : profile.IsBillingContact
        ? 'billing-contact primary-relation'
        : 'primary-relation'
    "
    
  >
    <div class="profile-icon">
      <wl-profile-type-icon
        [isMember]="profile.Member"
        [isOrg]="profile.OrgInd"
        [profileId]="profile.ProfileId"
        [memberTypeIconColor]="profile.MemberTypeIconColor"
        [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }"
      ></wl-profile-type-icon>
    </div>
    <div class="profile-name mct-flex mct-col" >
      <a (click)="viewRelatedProfile(profile.ProfileId)">{{ profile.ReportName }}</a>
      <div class="card-field-label">
        {{ profile.Title }}
      </div>
    </div>
    <div class="contact-info mct-flex mct-col" >
      <a [href]="'mailto:' + profile.Email">{{ profile.Email }}</a>
      <div class="profile-phone" *ngIf="profile.DisplayPhone">
        {{ profile.DisplayPhone | phone }}
      </div>
    </div>
    <div *ngIf="profile.IsMainContact" class="main-contact-label">
      {{ 'profiles.view.primary-relationships.main-contact' | translate | titlecase }}
    </div>
    <div *ngIf="!profile.IsMainContact && profile.IsBillingContact" class="billing-contact-label">
      {{ 'profiles.view.primary-relationships.billing-contact' | translate | titlecase }}
    </div>
  </div>
</div>
<div style="font-weight: bold;">
  <wl-paging-controls
    #pagingControls
    [pagedResult]="profileRelations"
    [hidden]="!showPaging"
    (pagingEvent)="onPagingEvent($event)"
  ></wl-paging-controls>
</div>

<wl-profile-relate-existing [profileId]="profileId"></wl-profile-relate-existing>

<wl-profile-create [parentProfileId]="profileId" [suspendNavigateAway]="true"></wl-profile-create>
